import { render, staticRenderFns } from "./expertWardDialog.vue?vue&type=template&id=c8a84c0e&scoped=true"
import script from "./expertWardDialog.vue?vue&type=script&lang=js"
export * from "./expertWardDialog.vue?vue&type=script&lang=js"
import style0 from "./expertWardDialog.vue?vue&type=style&index=0&id=c8a84c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a84c0e",
  null
  
)

export default component.exports